/**
 * Copyright 2025 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { Dispatch } from "react";
import { Col, Row } from "react-awesome-styled-grid";
import { useHistory } from "react-router-dom";
import { Heading, Message, Spacer, SVGIcon } from "@nordcloud/gnui";
import { InfoCard } from "~/components";
import { ROUTES } from "~/routing/routes";
import { useApplicationWizard } from "./ApplicationProvider";
import { defaultApplicationData } from "./constants";
import { State } from "./types";

type Props = {
  applicationId: string;
  updateState: Dispatch<Partial<State>>;
};
export function AfterApplicationCreation({ updateState }: Props) {
  const history = useHistory();
  const { setApplicationData } = useApplicationWizard();

  const onAddNewApplication = () => {
    updateState({ currentStep: 0, applicationCreated: false });
    setApplicationData(defaultApplicationData);
  };

  return (
    <Row justify="center">
      <Col sm={6} md={6} lg={8}>
        <Spacer height="1rem" />
        <Row>
          <Col>
            <Message status="success" image="success">
              The Application has been created.
            </Message>
          </Col>
        </Row>
        <Spacer height="2rem" />
        <Row>
          <Col lg={4}>
            <InfoCard align="center" onClick={() => {}}>
              <SVGIcon name="detailsView" size="xl" />
              <Heading marginTop="1rem" level={4}>
                Application Details
              </Heading>
            </InfoCard>
          </Col>
          <Col lg={4}>
            <InfoCard
              align="center"
              onClick={() => history.push(ROUTES.applications.index)}
            >
              <SVGIcon name="listView" size="xl" />
              <Heading marginTop="1rem" level={4}>
                List of Applications
              </Heading>
            </InfoCard>
          </Col>
          <Col lg={4}>
            <InfoCard align="center" onClick={onAddNewApplication}>
              <SVGIcon name="wizardView" size="xl" />
              <Heading marginTop="1rem" level={4}>
                Create New Application
              </Heading>
            </InfoCard>
          </Col>
        </Row>
      </Col>
    </Row>
  );
}
